import type { FC } from 'react';
import type { FilePreviewProps } from '.';
import { VideoJS } from '../video';

export const VideoPreview: FC<FilePreviewProps> = ({ downloadUrl, style }) => {
  return <VideoJS videoUrl={downloadUrl} style={style} />;
};
